import React from "react";
import { GridContainer, GridRow, GridColumn, Img } from "arv-reactcomponents";

import { Header } from "arv-extends";
import { Endpoints } from "npmlinks-constants";

const NavContainer = Header.DesktopHeader.DesktopNavContainer;

const {
  LoginActionButton,
  MyBagActionButton,
  SearchActionButton,
  StoreLocatorActionButton,
} = Header.ActionButtons;

const { wrapper, getFinalComponent } = Header.DesktopHeader.DesktopMainBar;

class HeaderDesktopMainBar extends wrapper {
  get logoImg() {
    const { navListData } = this.props.NavListStore;
    const alt = "Wildcraft image";
    const logoFromApi =
      (navListData &&
        navListData.data &&
        navListData.data.logos &&
        navListData.data.logos.nnnow &&
        navListData.data.logos.nnnow.image) ||
      null;
    const logoUrl = logoFromApi || Endpoints.nnnowLogoUrl;

    if (logoUrl) {
      return <Img className="nw-mainbar-logo" src={logoUrl} alt={alt} />;
    }
    return null;
  }

  render() {
    return (
      <GridContainer className="nw-mainbar-container">
        <GridRow className="nw-mainbar-row">
          <GridColumn className="nw-mainbar-col">
            <GridRow className="nw-mainbar-nav-row">
              <GridColumn className="nwc-grid-col-sm nw-mainbar-logo-container">
                <a
                  href="/"
                  target="_self"
                  className="nw-mainbar-logo-link"
                  onClick={HeaderDesktopMainBar.onLogoClick}
                >
                  {this.logoImg}
                </a>
              </GridColumn>
              <GridColumn
                className={`
                  nwc-grid-col-sm
                  nw-mainbar-navactions-col
                  ${this.isFixedClassName}
                `}
              >
                <GridRow className="nw-mainbar-navactions-row">
                  <GridColumn className="nwc-grid-col-sm nwc-custom-scrollbar nw-mainbar-nav-col">
                    <NavContainer.component />
                  </GridColumn>
                  <GridColumn className="nwc-grid-col-sm nw-mainbar-actionbuttons">
                    <SearchActionButton.component
                      className={`
                        nw-mainbar-actionbutton
                        nw-mainbar-actionbutton-search
                        ${this.isFixedClassName}
                      `}
                    />
                    <StoreLocatorActionButton.component
                      className={`
                        nw-mainbar-actionbutton
                        nw-mainbar-actionbutton-storelocator
                        ${this.isFixedClassName}
                      `}
                    />
                    <LoginActionButton.component
                      className={`
                        nw-mainbar-actionbutton
                        nw-mainbar-actionbutton-login
                        ${this.isFixedClassName}
                      `}
                    />
                    <MyBagActionButton.component
                      className={`
                        nw-mainbar-actionbutton
                        nw-mainbar-actionbutton-mybag
                        ${this.isFixedClassName}
                      `}
                    />
                  </GridColumn>
                </GridRow>
              </GridColumn>
            </GridRow>
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
  }
}

Header.DesktopHeader.DesktopMainBar.component = getFinalComponent(
  HeaderDesktopMainBar,
);
